"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChipsContainer = void 0;
const react_1 = __importStar(require("react"));
const predicate_language_1 = require("@groupby/predicate-language");
const ramda_1 = require("ramda");
const react_redux_1 = require("react-redux");
const chips_component_1 = require("./chips.component");
const hooks_1 = require("../../hooks");
const localization_1 = require("../../localization");
const store_1 = require("../../store");
const State = __importStar(require("../../store/state"));
const ChipsContainer = ({ className, onClear }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const includedCategoriesIds = (0, store_1.useProductsIncludedCategoriesIds)();
    const excludedCategoriesIds = (0, store_1.useProductsExcludedCategoriesIds)();
    const includedAttributesIds = (0, store_1.useProductsIncludedAttributesIds)();
    const excludedAttributesIds = (0, store_1.useProductsExcludedAttributesIds)();
    const categoriesMap = (0, store_1.useCategoriesMapSelector)();
    const formalAttributesMap = (0, store_1.useFormalAttributesMapSelector)();
    const formalAttributeValuesMap = (0, store_1.useFormalAttributeValuesMapSelector)();
    const includedTaxonomyClassIds = (0, store_1.useProductsIncludedTaxonomyClassIds)();
    const excludedTaxonomyClassIds = (0, store_1.useProductsExcludedTaxonomyClassIds)();
    const activeFilter = (0, store_1.useProductsFilterActive)();
    const taxonomyClasses = (0, store_1.useClassesSelector)();
    const client = (0, hooks_1.useEnrichClient)();
    const mapCategoryToItem = (0, react_1.useCallback)((category, itemType) => {
        const onDelete = itemType === 'included'
            ? () => dispatch((0, store_1.productsSetIncludedCategoriesIds)((0, ramda_1.without)([category.id], includedCategoriesIds)))
            : () => dispatch((0, store_1.productsSetExcludedCategoriesIds)((0, ramda_1.without)([category.id], excludedCategoriesIds)));
        return {
            id: category.id,
            label: category.title,
            type: itemType,
            onDelete,
        };
    }, [dispatch, excludedCategoriesIds, includedCategoriesIds]);
    const mapTaxonomyClass = (0, react_1.useCallback)((taxonomyClass, itemType) => {
        const onDelete = itemType === 'included'
            ? () => dispatch((0, store_1.productsSetIncludedTaxonomyClassIds)(taxonomyClass.id))
            : () => dispatch((0, store_1.productsSetExcludedTaxonomyClassIds)(taxonomyClass.id));
        return {
            id: taxonomyClass.id,
            label: taxonomyClass.title,
            type: itemType,
            onDelete,
        };
    }, [dispatch]);
    (0, react_1.useEffect)(() => {
        const uniqueAttributeIds = (0, ramda_1.uniq)(includedAttributesIds.concat(excludedAttributesIds)
            .map((joinedAttributeId) => joinedAttributeId.split(store_1.ATTRIBUTE_PROPERTY_DELIMITER, 2)[0]));
        const missingAttributeIds = (0, ramda_1.without)([...formalAttributesMap.keys()], uniqueAttributeIds);
        if (missingAttributeIds.length) {
            const maxPageSize = 100;
            const attributeIdsToFetch = missingAttributeIds.slice(0, maxPageSize);
            client.formalAttributeNames.getMany({
                page: { limit: attributeIdsToFetch.length },
                filter: new predicate_language_1.PredicateBuilder((0, predicate_language_1.where)((0, predicate_language_1.f) `id`, '@<', attributeIdsToFetch.map((id) => (0, predicate_language_1.uuid)(id)))),
            }).then((data) => {
                dispatch((0, store_1.attributesSetFormalAttributes)(data));
            }, (err) => {
                console.error(err);
            });
        }
        const uniqueAttributeValueIds = (0, ramda_1.uniq)(includedAttributesIds.concat(excludedAttributesIds)
            .map((joinedAttributeId) => joinedAttributeId.split(store_1.ATTRIBUTE_PROPERTY_DELIMITER, 3)[1]))
            .filter((a) => !!a);
        const missingAttributeValueIds = (0, ramda_1.without)([...formalAttributeValuesMap.keys()], uniqueAttributeValueIds);
        if (missingAttributeValueIds.length) {
            const maxPageSize = 100;
            const attributeValueIdsToFetch = missingAttributeValueIds.slice(0, maxPageSize);
            client.formalAttributeValues.getMany({
                page: { limit: attributeValueIdsToFetch.length },
                filter: new predicate_language_1.PredicateBuilder((0, predicate_language_1.where)((0, predicate_language_1.f) `id`, '@<', attributeValueIdsToFetch.map((id) => (0, predicate_language_1.uuid)(id)))),
            }).then((data) => {
                dispatch((0, store_1.attributesSetFormalAttributeValues)(data));
            }, (err) => {
                console.error(err);
            });
        }
    }, [dispatch, client, includedAttributesIds, excludedAttributesIds, formalAttributesMap, formalAttributeValuesMap]);
    const mapAttributeIdToItem = (0, react_1.useCallback)((joinedAttributeId, itemType) => {
        var _a, _b, _c, _d;
        const [attributeId, valueId, valueName] = joinedAttributeId.split(store_1.ATTRIBUTE_PROPERTY_DELIMITER);
        const onDelete = itemType === 'included'
            ? () => dispatch((0, store_1.productsSetIncludedAttributesIds)((0, ramda_1.without)([joinedAttributeId], includedAttributesIds)))
            : () => dispatch((0, store_1.productsSetExcludedAttributesIds)((0, ramda_1.without)([joinedAttributeId], excludedAttributesIds)));
        return {
            id: joinedAttributeId,
            label: [(_b = (_a = formalAttributesMap.get(attributeId)) === null || _a === void 0 ? void 0 : _a.displayName) !== null && _b !== void 0 ? _b : attributeId, (_d = (_c = formalAttributeValuesMap.get(valueId)) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : (valueName || valueId)].filter((a) => !!a).join(': '),
            type: itemType,
            onDelete,
        };
    }, [dispatch, includedAttributesIds, excludedAttributesIds, formalAttributesMap, formalAttributeValuesMap]);
    const activeFilterItem = (0, react_1.useMemo)(() => ({
        id: 'activeFilterItem',
        label: t({ key: activeFilter }),
        type: chips_component_1.ITEM_TYPE.INCLUDED,
        onDelete: () => dispatch((0, store_1.productsSetFilterActive)(State.ProductFilterActiveTypes.All)),
    }), [activeFilter, dispatch]);
    const items = (0, react_1.useMemo)(() => {
        const chips = [activeFilterItem];
        includedCategoriesIds.forEach((id) => categoriesMap[id] && chips.push(mapCategoryToItem(categoriesMap[id], chips_component_1.ITEM_TYPE.INCLUDED)));
        excludedCategoriesIds.forEach((id) => categoriesMap[id] && chips.push(mapCategoryToItem(categoriesMap[id], chips_component_1.ITEM_TYPE.EXCLUDED)));
        includedTaxonomyClassIds.forEach((id) => taxonomyClasses.byId[id] && chips.push(mapTaxonomyClass(taxonomyClasses.byId[id], chips_component_1.ITEM_TYPE.INCLUDED)));
        excludedTaxonomyClassIds.forEach((id) => taxonomyClasses.byId[id] && chips.push(mapTaxonomyClass(taxonomyClasses.byId[id], chips_component_1.ITEM_TYPE.EXCLUDED)));
        includedAttributesIds.forEach((id) => chips.push(mapAttributeIdToItem(id, chips_component_1.ITEM_TYPE.INCLUDED)));
        excludedAttributesIds.forEach((id) => chips.push(mapAttributeIdToItem(id, chips_component_1.ITEM_TYPE.EXCLUDED)));
        return chips;
    }, [
        activeFilterItem,
        includedCategoriesIds,
        excludedCategoriesIds,
        includedTaxonomyClassIds,
        excludedTaxonomyClassIds,
        includedAttributesIds,
        excludedAttributesIds,
        mapCategoryToItem,
        mapAttributeIdToItem,
        categoriesMap,
        mapTaxonomyClass,
        taxonomyClasses.byId,
    ]);
    const handleClear = (0, react_1.useCallback)(() => {
        if (onClear) {
            onClear();
        }
        dispatch((0, store_1.productsSetIncludedCategoriesIds)([]));
        dispatch((0, store_1.productsSetExcludedCategoriesIds)([]));
        dispatch((0, store_1.productsClearIncludedTaxonomyClassIds)());
        dispatch((0, store_1.productsClearExcludedTaxonomyClassIds)());
        dispatch((0, store_1.productsSetIncludedAttributesIds)([]));
        dispatch((0, store_1.productsSetExcludedAttributesIds)([]));
        dispatch((0, store_1.productsSetFilterActive)(State.ProductFilterActiveTypes.All));
    }, [dispatch, onClear]);
    return react_1.default.createElement(chips_component_1.Chips, { className: className, items: items, onClear: handleClear });
};
exports.ChipsContainer = ChipsContainer;
exports.default = exports.ChipsContainer;
